<div id="updates-container">
    <div id="updates-content-container">
        <div class="section-title-container">
            <h2 class="section-title">Novedades</h2>
        </div>
        
        <div id="updates-general-container">
            <app-wide-update-card [update]="updates[0]" class="update-card-self"></app-wide-update-card>
            <div id="updates-card-container">
                @for (update of updates.slice(1); track $index) {
                    <app-update-card [update]="update" class="update-card-self"></app-update-card>
                }
            </div>
        </div>
    </div>
</div>